// Static copy for the GCC cashier redesign. The engine-driven views own all
// money/method/bonus data now; the only literals kept here are the per-view
// header copy (VIEW_META) and the generic integer formatter (formatAmount).
// The previous fake fallbacks (fabricated methods, bonuses, presets, balances
// and history rows) were removed: authenticated views must never render sample
// payment methods a player can select and submit against.
import { __ } from "services/Translator";

export const VIEW_META = {
  deposit: [__("Deposit"), __("Fund your account in two quick steps.")],
  withdraw: [__("Withdrawal"), __("Cash out your winnings, fast.")],
  bonuses: [__("Bonuses"), __("Your active rewards and offers to claim.")],
  vip: [__("VIP Level"), __("Your tier, perks and progress.")],
  history: [__("History"), __("Recent deposits, withdrawals and bonuses.")],
  limits: [__("Limits & Safety"), __("Stay in control of your play.")],
};

export function formatAmount(n) {
  return Number(n || 0).toLocaleString("en-US");
}
